const actions = {
  SET_STATE: 'payment/SET_STATE',
  INIT_PAYMENT: 'payment/INIT_PAYMENT',
  STORE_CREDS: 'payment/STORE_CREDS',
}

export default actions
